window.addEventListener('alpine:init', () => {
  Alpine.data('searchModalData', () => ({
    open: false,

    toggle() {
      this.open = !this.open;
    },

    init() {
      const triggers = document.querySelectorAll('[data-trigger-search]');
      if(!triggers?.length) return;

      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          this.toggle();
        })
      });
    }
  }));
});